import { useEffect } from "react";
import { C, font } from "../theme";

export function Snackbar({ message, kind = "error", onClose }: { message: string; kind?: "error" | "success"; onClose: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onClose, 4500);
    return () => window.clearTimeout(timer);
  }, [message, onClose]);

  return <div role="status" aria-live="polite" style={{ position: "fixed", right: 20, bottom: 20, zIndex: 100, maxWidth: 420, padding: "12px 16px", border: `1px solid ${kind === "error" ? C.red : C.lime}`, borderRadius: 10, color: kind === "error" ? C.red : C.ink, background: kind === "error" ? C.redSoft : C.limeSoft, boxShadow: "0 8px 24px rgba(17,17,17,0.14)", fontFamily: font, fontSize: 13, fontWeight: 600 }}>{message}</div>;
}
